import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setQuantNaoLidas } from "./SalaParticipante/actions/actions";
import SalaListItem from "./MensagemTable/SalaListItem";

const MensagemUser = ({ sp, getNameRoom }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const quantNaoLidas = useSelector((state) => state.quantNaoLidas);

  const handleSalaMensagem = () => {
    if (sp.quantNaoLidas > 0) {
      dispatch(setQuantNaoLidas(quantNaoLidas - sp.quantNaoLidas));
    }
    navigate("/sala-mensagem", {
      state: {
        salaParticipante: sp,
        nameRoom: getNameRoom(sp),
      },
    });
  };

  return (
    <SalaListItem
      sala={sp.sala}
      usuarios={[sp.usuario]}
      title={sp.sala.isGroup ? `Grupo: ${sp.sala.descricao}` : sp.usuario.nome}
      quantNaoLidas={sp.quantNaoLidas}
      onOpen={handleSalaMensagem}
    />
  );
};

export default MensagemUser;
